import React, { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'component/Loadable';

// eslint-disable-next-line no-unused-vars
import StoreLayout from 'views/Stores/Table/layout';
import EditStore from 'views/Team/updateStore';
import ProtectedRoute from './ProtectedRoute';
import NotFound from 'views/NotFound/NotFound';
import NewStorePage from 'views/Stores/Insight/newStorePage';
import Overview from 'views/Stores/Insight/overview';
import Videos from 'views/Stores/Insight/videos';
import Anomalies from 'views/Stores/Insight/Anomalies/anomalies';
import VMFixtures from 'views/Settings/VMFixtures';
import UserProfile from 'views/UserProfile';
import StoreOverviewLayout from 'views/Stores/Table/layout2';
import BayDetails from 'views/Stores/Table/bayDetails';
import AgentBayAssignment from 'views/Stores/Insight/AgentBay';
import Gallery from 'views/Stores/Insight/Gallery/Gallery';

const Insight = Loadable(lazy(() => import('../views/Insights')));

const Brands = Loadable(lazy(() => import('../views/Brands')));

const Customers = Loadable(lazy(() => import('../views/Customers')));

const Team = Loadable(lazy(() => import('../views/Team')));

const UtilsTypography = Loadable(lazy(() => import('../views/Utils/Typography')));

const SamplePage = Loadable(lazy(() => import('../views/SamplePage')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/main',
  element: <ProtectedRoute element={<MainLayout />} />,
  children: [
    {
      path: '/main/insights',
      element: <Insight />
    },
    {
      path: '/main/stores/layout/:store',
      element: <StoreOverviewLayout />
    },
    {
      path: '/main/stores/bay-details/:bayId',
      element: <BayDetails />
    },
    {
      path: '/main/brands',
      element: <Brands />
    },
    {
      path: '/main/stores',
      element: <Customers />
    },
    {
      path: '/main/stores/storeinsight',
      element: <NewStorePage />,
      children: [
        {
          path: '/main/stores/storeinsight/overview/:storeId',
          element: <Overview />
        },
        {
          path: '/main/stores/storeinsight/anomalies/:storeId',
          element: <Anomalies />
        },
        {
          path: '/main/stores/storeinsight/agentbay/:storeId',
          element: <AgentBayAssignment />
        },
        {
          path: '/main/stores/storeinsight/gallery/:store_id',
          element: <Gallery />
        },
        {
          path: '/main/stores/storeinsight/video',
          element: <Videos />
        }
      ]
    },
    {
      path: '/main/team',
      element: <Team />,
      children: [
        {
          path: 'edit/:id',
          element: <EditStore />
        }
      ]
    },
    {
      path: '/main/vm-fixtures',
      element: <VMFixtures />
    },
    {
      path: '/main/user-profile',
      element: <UserProfile />
    },
    { path: '/main/utils/util-typography', element: <UtilsTypography /> },
    { path: '/main/sample-page', element: <SamplePage /> },
    { path: '*', element: <NotFound btn="Go back" flag="1" /> }
  ]
};

export default MainRoutes;
